export default "__VITE_ASSET__CARMn_rf__"